import _formatTags from "../../dict/formatTags.js";
const formatTags = _formatTags;
export default (function replaceItalicTags(text, openTag, closeTag) {
  let openPattern = new RegExp(formatTags.italics.open, "gmi"),
    closePattern = new RegExp(formatTags.italics.close, "gmi");
  return text.replace(openPattern, openTag).replace(closePattern, closeTag);
});